// Shared MyPrinter panel manager — dùng chung hub (/pages/mypage) + trang /pages/printers.
// Card 対応商品 theo design account/printers.html + index.html: ảnh + badges
// (当日出荷 [AJAX] / 送料無料 [SSR 税込≥4000] / 在庫あり [AJAX]) + tên + giá 税込 + %お得 (price_ref)
// + khu mua (contract cart-add.js: qty + カートに入れる) hoặc 自由選択 → カラーを選択する.
// Panel: pulldown chọn printer (正本) + メモ (PATCH /printer/{id}) + 削除 + [add form tùy chọn].
// Stock hydrate: GET /api/v1/stock?skus= (fail-open, KHÔNG chặn user). Add-to-cart qua cart-add.js global.
// Export: window.InkPrinterManager = { renderProducts, initPanel }.

(function () {
  'use strict';

  const PROXY_BASE = ((window.INK_API_CONFIG && window.INK_API_CONFIG.proxyBase) || '/apps/ink').replace(/\/$/, '');
  const STOCK_URL = PROXY_BASE + '/api/v1/stock';
  const STOCK_BATCH_MAX = 50; // StockController limit

  const fmt = (n) => Number(n || 0).toLocaleString('ja-JP');
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

  // %お得 = 100 − round(税込 × 100 / 参考価格). Cùng đơn vị yen (§JPY). Chỉ hiện khi có ref & > 0.
  function otoku(price, ref) {
    if (!ref || !price) return 0;
    return 100 - Math.round((price * 100) / ref);
  }

  // Card 対応商品 (design). opts.detailLink = thêm nút「商品説明や特長を見る」(hub design có, printers page không).
  function productCard(pr, opts) {
    opts = opts || {};
    const url = pr.shopify_handle ? '/products/' + esc(pr.shopify_handle) : '#';
    // 自由選択 phải chọn màu ở PDP mới mua được, mà product CHA vẫn có variant nên
    // chỉ nhìn `shopify_variant_id` là hiện nút mua và add nhầm cha vào giỏ.
    const hasVariant = !!pr.shopify_variant_id && !pr.select_flg;
    const img = pr.image
      ? `<img class="max-h-full w-full object-contain" src="${esc(pr.image)}" alt="${esc(pr.name)}" loading="lazy">`
      : '<span class="flex h-full w-full items-center justify-center bg-gray-100 text-[10px] text-gray-400">画像準備中</span>';
    // 送料無料 = 税込 ≥ 4000 (browse_6_new_cart.php); 在庫 = skeleton chờ AJAX; 当日出荷 = ẩn→AJAX.
    // Badge 在庫/当日出荷 chỉ render khi có sku (hydrateStock cần sku; không sku → tránh kẹt skeleton).
    const shipFree = pr.price != null && Number(pr.price) >= 4000
      ? '<span class="ik-badge ik-badge--shipping">送料無料</span>' : '';
    const samedayBadge = pr.sku ? '<span class="ik-badge ik-badge--same-day hidden" data-sameday-badge>当日出荷</span>' : '';
    const stockBadge = pr.sku ? '<span class="ik-badge ik-badge--stock" data-stock-badge><span class="inline-block h-3 w-10 animate-pulse rounded bg-black/10"></span></span>' : '';
    // Thứ tự khớp design: 当日出荷 → 送料無料 → 在庫あり.
    const badges = (samedayBadge || shipFree || stockBadge)
      ? `<div class="mt-3 flex flex-wrap gap-1.5">${samedayBadge}${shipFree}${stockBadge}</div>`
      : '';
    const price = pr.price != null
      ? `<p class="mt-2 text-ink-red"><span class="mr-1 text-xs font-bold text-ink-black">税込</span><span class="text-2xl font-bold leading-none">${fmt(pr.price)}</span><span class="ml-0.5 text-xs font-bold text-ink-black">円</span></p>`
      : '';
    // %お得: 自由選択 (không variant) → "純正より最大 X%お得" (giá tối thiểu set); thường → "純正より X%お得".
    const pct = otoku(Number(pr.price), Number(pr.price_ref));
    const otokuLine = pct > 0
      ? `<p class="mt-1 text-sm font-bold text-ink-green">純正より${hasVariant ? '' : '最大'} ${pct}%お得</p>`
      : '';
    // Stepper [−][input][＋] — VISUAL copy 1:1 khu mua của `category-product-card`
    // (phải khớp category page, không dùng style xám của
    // `add-to-cart-block`). Chỉ khác ATTRS: giữ contract cart-add.js
    // [data-qty-dec]/[data-qty-val]/[data-qty-inc] trong [data-ink-cart-item]
    // (category dùng data-qty-minus/input/plus vì collection.js xử lý riêng).
    const buy = hasVariant
      ? `<div data-buy>
           <div class="flex items-center justify-between gap-2 text-xs font-bold" data-ink-cart-item>
             <span>数量</span>
             <div class="grid h-9 overflow-hidden rounded border border-ink-grayLine bg-white" style="width:104px;grid-template-columns:34px 36px 34px">
               <button class="border-r border-ink-grayLine text-base font-bold" type="button" aria-label="数量を減らす" data-qty-dec>−</button>
               <input class="min-w-0 [appearance:textfield] text-center text-sm font-bold outline-none [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none" type="number" min="1" max="99" value="1" data-qty-val aria-label="数量">
               <button class="border-l border-ink-grayLine text-base font-bold" type="button" aria-label="数量を増やす" data-qty-inc>＋</button>
             </div>
           </div>
           <button type="button" data-ink-add-cart data-variant-id="${pr.shopify_variant_id}" class="mt-2 min-h-10 w-full rounded bg-ink-orange px-3 text-sm font-bold text-white transition-opacity hover:opacity-90 disabled:opacity-50">カートに入れる</button>
         </div>`
      : `<div class="flex items-center gap-2" data-buy>
           <span class="inline-flex min-h-10 w-14 items-center justify-center rounded bg-ink-orange text-center text-xs font-bold leading-tight text-white">自由<br>選択</span>
           <a href="${url}" class="inline-flex min-h-10 flex-1 items-center justify-center rounded bg-ink-orange px-3 text-sm font-bold text-white no-underline">カラーを選択する</a>
         </div>`;
    const soldout = '<div class="hidden items-center justify-center rounded bg-gray-100 py-2.5 text-sm font-bold text-gray-500" data-soldout aria-disabled="true">ただいま販売しておりません</div>';
    const detail = opts.detailLink
      ? `<a class="mt-3 inline-flex min-h-10 items-center justify-center rounded bg-gray-100 px-3 text-sm font-bold text-gray-700 no-underline" href="${url}">商品説明や特長を見る</a>`
      : '';
    return `<article class="flex min-w-0 flex-col rounded border border-gray-100 bg-white p-3 shadow-soft" data-printer-card data-sku="${esc(pr.sku || '')}" data-ink-cart-item>
      <a class="flex h-40 items-center justify-center bg-white" href="${url}">${img}</a>
      ${badges}
      <a class="mt-2 min-w-0 no-underline" href="${url}"><h3 class="ik-line-clamp-2 text-sm font-bold leading-5 text-ink-blue">${esc(pr.name)}</h3></a>
      ${price}
      ${otokuLine}
      <div class="mt-3">${buy}${soldout}</div>
      ${detail}
    </article>`;
  }

  // ===== Stock hydrate (fail-open) =====
  async function hydrateStock(container) {
    const cards = Array.from(container.querySelectorAll('[data-printer-card][data-sku]')).filter((c) => c.dataset.sku);
    if (!cards.length) return;
    const skus = Array.from(new Set(cards.map((c) => c.dataset.sku)));
    for (let i = 0; i < skus.length; i += STOCK_BATCH_MAX) {
      const chunk = skus.slice(i, i + STOCK_BATCH_MAX);
      let items;
      try {
        const res = await fetch(STOCK_URL + '?skus=' + encodeURIComponent(chunk.join(',')), {
          headers: { Accept: 'application/json', 'ngrok-skip-browser-warning': '1' },
          credentials: 'same-origin',
        });
        const json = await res.json();
        items = json && json.data && json.data.items;
      } catch (e) {
        console.warn('[printer] stock fetch failed', e);
        cards.forEach(fallbackStock);
        return;
      }
      if (!items) { cards.filter((c) => chunk.indexOf(c.dataset.sku) !== -1).forEach(fallbackStock); continue; }
      cards.filter((c) => chunk.indexOf(c.dataset.sku) !== -1).forEach((c) => applyStock(c, items[c.dataset.sku]));
    }
  }
  function applyStock(card, stock) {
    const status = stock && stock.status;
    const inStock = status === 'in_stock';
    // CHỈ 'out_of_stock' = hết hàng CHẮC CHẮN → badge 在庫なし. 'unknown'/thiếu entry =
    // KHÔNG resolve được stock → fail-open (KHÔNG hiện 在庫なし).
    const soldOut = status === 'out_of_stock';
    // Nút mua chỉ ẩn khi 販売終了/完売 (buy_enable=false — jos_vm_cart_close).
    // CHECK_STOCK='' nên 在庫なし VẪN mua được (ps_product.php checkBuyEnable),
    // giống card category (collection.js).
    const buyEnable = !stock || stock.buy_enable !== false;
    const badge = card.querySelector('[data-stock-badge]');
    const sameday = card.querySelector('[data-sameday-badge]');
    const buy = card.querySelector('[data-buy]');
    const soldout = card.querySelector('[data-soldout]');
    if (badge) {
      // Màu inline (Tailwind JIT không thấy class runtime).
      if (inStock) {
        badge.textContent = '在庫あり'; badge.style.color = '#07832a'; badge.style.background = '#eefaf0';
      } else if (soldOut) {
        badge.textContent = '在庫なし'; badge.style.color = '#999999'; badge.style.background = '#f2f2f2';
      } else {
        badge.style.display = 'none'; // unknown → ẩn badge (không claim あり/なし)
      }
    }
    // 当日出荷 = chỉ khi CHẮC còn hàng (by-printer API không trả reserve_flg → không gate 予約).
    if (sameday) sameday.classList.toggle('hidden', !inStock);
    if (buyEnable) {
      if (buy) buy.classList.remove('hidden');
      if (soldout) soldout.classList.add('hidden');
    } else {
      if (buy) buy.classList.add('hidden');
      if (soldout) { soldout.classList.remove('hidden'); soldout.classList.add('flex'); }
    }
  }
  // Fail-open: ẩn badge 在庫 (không claim 在庫あり giả, tránh ô rỗng), giữ nút mua (guard mua thật ở server).
  function fallbackStock(card) {
    const badge = card.querySelector('[data-stock-badge]');
    if (badge && badge.querySelector('.animate-pulse')) badge.style.display = 'none';
  }

  function renderProducts(container, products, opts) {
    if (!container) return;
    if (!products || !products.length) {
      container.innerHTML = '<p class="col-span-full text-sm text-gray-500">対応商品が見つかりませんでした。</p>';
      return;
    }
    container.innerHTML = products.map((p) => productCard(p, opts)).join('');
    hydrateStock(container);
  }

  // ===== Panel manager (switcher + memo + delete + optional add form) =====
  function initPanel(root, opts) {
    opts = opts || {};
    if (!root || !window.inkApi) return;
    const detailLink = !!opts.detailLink;
    const selectEl = root.querySelector('[data-printer-select]');
    const productsEl = root.querySelector('[data-printer-products]');
    const titleEl = root.querySelector('[data-printer-title]');
    const deleteBtn = root.querySelector('[data-printer-delete]');
    const emptyEl = root.querySelector('[data-printer-empty]');
    const panelEl = root.querySelector('[data-printer-panel]');

    let printers = [];
    let selectedId = null;

    async function loadPrinters() {
      let items = [];
      try {
        const j = await window.inkApi.get('/printer', { sort: 1 });
        items = (j && j.data) || [];
      } catch (e) {
        root.querySelector('[data-printers-guest]')?.classList.remove('hidden');
        if (panelEl) panelEl.classList.add('hidden');
        return;
      }
      printers = items;
      if (!items.length) {
        if (panelEl) panelEl.classList.add('hidden');
        if (emptyEl) emptyEl.classList.remove('hidden');
        return;
      }
      if (emptyEl) emptyEl.classList.add('hidden');
      if (panelEl) panelEl.classList.remove('hidden');
      if (!selectedId || !items.some((p) => String(p.id) === String(selectedId))) selectedId = items[0].id;
      renderSelect();
      selectPrinter(selectedId);
    }

    function renderSelect() {
      if (!selectEl) return;
      selectEl.classList.remove('animate-pulse');
      selectEl.innerHTML = printers.map((p) => `<option value="${p.id}"${String(p.id) === String(selectedId) ? ' selected' : ''}>${esc(p.printer_name)}</option>`).join('');
    }

    async function selectPrinter(id) {
      selectedId = id;
      renderSelect();
      const p = printers.find((x) => String(x.id) === String(id));
      if (titleEl) titleEl.textContent = (p ? p.printer_name : '') + ' に対応した商品';
      const memoEl = root.querySelector('[data-printer-memo]');
      if (memoEl) memoEl.value = (p && p.note) || '';
      const memoMsg = root.querySelector('[data-printer-memo-msg]');
      if (memoMsg) memoMsg.textContent = '';
      if (!productsEl) return;
      productsEl.innerHTML = '<div class="col-span-full h-28 animate-pulse rounded bg-gray-200"></div>';
      try {
        const j = await window.inkApi.get(`/products/by-printer/${id}`);
        const prods = (j && j.data && j.data.products) || [];
        renderProducts(productsEl, prods, { detailLink });
      } catch (e) {
        productsEl.innerHTML = '<p class="col-span-full text-sm text-gray-500">対応商品を取得できませんでした。</p>';
      }
    }

    selectEl?.addEventListener('change', () => selectPrinter(selectEl.value));

    // メモ保存 — PATCH /printer/{id} {note} (UpdateNoteRequest: key note bắt buộc, nullable).
    root.querySelector('[data-printer-memo-save]')?.addEventListener('click', async () => {
      if (!selectedId) return;
      const memoEl = root.querySelector('[data-printer-memo]');
      const memoMsg = root.querySelector('[data-printer-memo-msg]');
      if (!memoEl) return;
      const note = memoEl.value.trim();
      window.inkProcessing?.show();
      try {
        const j = await window.inkApi.patch(`/printer/${selectedId}`, { note: note || null });
        if (j && j.data) {
          const p = printers.find((x) => String(x.id) === String(selectedId));
          if (p) p.note = j.data.note;
          if (memoMsg) { memoMsg.textContent = '保存しました'; memoMsg.className = 'text-sm font-bold text-ink-green'; setTimeout(() => { memoMsg.textContent = ''; }, 2000); }
        } else if (memoMsg) {
          memoMsg.textContent = (j && j.message) || '保存に失敗しました'; memoMsg.className = 'text-sm text-ink-red';
        }
      } catch (e) {
        if (memoMsg) { memoMsg.textContent = '保存に失敗しました'; memoMsg.className = 'text-sm text-ink-red'; }
      } finally { window.inkProcessing?.hide(); }
    });

    deleteBtn?.addEventListener('click', async () => {
      if (!selectedId) return;
      if (!window.confirm('選択中のプリンターを削除してよろしいですか？')) return;
      window.inkProcessing?.show();
      try {
        const res = await window.inkApi.delete(`/printer/${selectedId}`);
        // inkApi.delete trả {error} (KHÔNG throw) khi 4xx/5xx/network → check trước khi
        // báo thành công, tránh toast giả khi printer VẪN còn đăng ký.
        if (!res || res.error) { window.alert('削除に失敗しました。'); return; }
        selectedId = null;
        await loadPrinters();
        // Toast để user nắm bắt (delete trên panel không có slot inline như form đăng ký).
        window.inkToast?.('プリンターを削除しました。');
      }
      catch (e) { window.alert('削除に失敗しました。'); }
      finally { window.inkProcessing?.hide(); }
    });

    // ===== add printer form (chỉ /pages/printers) — box プリンター候補 (grid nút) inline dưới input =====
    const addForm = root.querySelector('[data-printer-add-form]');
    if (addForm) {
      const input = addForm.querySelector('input[name=search]');
      const listEl = addForm.querySelector('[data-printer-suggest-list]');
      const gridEl = addForm.querySelector('[data-printer-suggest-grid]');
      const hiddenId = addForm.querySelector('input[name=category_id]');
      const msg = addForm.querySelector('[data-printer-add-msg]');
      const status = addForm.querySelector('[data-printer-search-status]');
      const SPIN = '<span class="ink-spin"></span>';
      const showS = (h) => { if (status) { status.innerHTML = h; status.classList.remove('hidden'); status.classList.add('inline-flex'); } };
      const hideS = () => { if (status) { status.classList.add('hidden'); status.classList.remove('inline-flex'); status.innerHTML = ''; } };
      const closeList = () => { listEl.classList.add('hidden'); gridEl.innerHTML = ''; input.setAttribute('aria-expanded', 'false'); };
      const openList = () => { listEl.classList.remove('hidden'); input.setAttribute('aria-expanded', 'true'); };
      let timer;
      input.addEventListener('input', () => {
        clearTimeout(timer); hiddenId.value = '';
        const q = input.value.trim();
        if (q.length < 2) { hideS(); closeList(); return; }
        showS(SPIN + '<span>検索中…</span>');
        timer = setTimeout(async () => {
          try {
            const j = await window.inkApi.get('/printer/suggest', { q });
            const its = (j && j.data) || [];
            if (!its.length) { autoRegisterName = null; closeList(); showS('<span>該当する型番がありません</span>'); return; }
            // Chỉ auto-select cho lượt đến từ link mail: tên trong link không khớp
            // chính xác category nào, nhưng LIKE ra đúng 1 candidate ⇒ điền sẵn để
            // khách xác nhận. KHÔNG tự submit — tên candidate có thể khác tên trong
            // mail (「EP-802A」 vs 「EP-802A（生産終了）」) và Joomla ở ca này không
            // đăng ký gì cả. Lượt gõ tay không auto-select: ghi đè chữ khách đang nhập.
            if (its.length === 1 && autoRegisterName) {
              autoRegisterName = null;
              input.value = its[0].category_name; hiddenId.value = its[0].category_id;
              closeList();
              showS('<span>この型番でよろしければ「登録」を押してください</span>');
              return;
            }
            gridEl.innerHTML = its.map((c, i) => `<button type="button" role="option" data-suggest data-id="${c.category_id}" class="${i % 2 === 0 ? 'bg-gray-50' : 'bg-gray-100'} px-2 py-4 hover:bg-ink-paleGreen">${esc(c.category_name)}</button>`).join('');
            openList();
            showS(`<span>${its.length}件の候補（下から選択）</span>`);
          } catch (e) { closeList(); showS('<span class="text-ink-red">検索に失敗しました</span>'); }
        }, 500);
      });
      listEl.addEventListener('click', (e) => {
        const b = e.target.closest('[data-suggest]');
        if (!b) return;
        input.value = b.textContent; hiddenId.value = b.dataset.id; closeList(); hideS();
      });
      document.addEventListener('click', (e) => { if (!addForm.contains(e.target)) closeList(); });
      input.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeList(); });
      // Nút × trên header box候補 — đóng box + ẩn dòng đếm 件数 (không đụng input).
      addForm.querySelector('[data-printer-suggest-close]')?.addEventListener('click', () => { closeList(); hideS(); });

      // Link 「マイプリンターに登録」 trong mail batch legacy gửi
      // `/pages/printers?printer=<型番>`. Joomla `my_printer.register.php` đăng ký
      // NGAY khi mở link (`getCategoryId` khớp `category_name` → `InsertPrinter`),
      // nên gọi `/printer/by-name` trước; tên không khớp category nào mới lùi về
      // luồng suggest để khách chọn.
      let autoRegisterName = null;
      const preset = (new URLSearchParams(window.location.search).get('printer') || '').trim();
      if (preset.length >= 2) {
        registerByName(preset);
      }

      async function registerByName(name) {
        window.inkProcessing?.show();
        try {
          const j = await window.inkApi.post('/printer/by-name', { printer_name: name });
          if (j && j.data && j.data.id) {
            msg.textContent = '登録しました'; msg.className = 'text-sm font-bold text-ink-green lg:col-span-3';
            selectedId = j.data.id;
            await loadPrinters();
            setTimeout(() => { msg.textContent = ''; }, 2000);
            return;
          }
          if (j && j.error === 'printer_already_registered') {
            msg.textContent = 'このプリンターはすでに登録されています。'; msg.className = 'text-sm text-ink-red lg:col-span-3';
            return;
          }
        } catch (e) {
          console.warn('register printer by name fail', e);
        } finally {
          window.inkProcessing?.hide();
        }

        // `category_not_printer` (không có category tên đó) hoặc lỗi tạm thời →
        // để khách tự chọn từ candidate; đúng 1 candidate thì tự submit.
        autoRegisterName = name;
        input.value = name;
        input.dispatchEvent(new Event('input'));
      }
      addForm.addEventListener('submit', async (e) => {
        e.preventDefault();
        if (!hiddenId.value) { msg.textContent = 'プリンターを選択してください'; msg.className = 'text-sm text-ink-red lg:col-span-3'; return; }
        // Alert khi đăng ký TRÙNG (#7.4): check client-side trước POST — printer đã có category_id này.
        if (printers.some((p) => String(p.category_id) === String(hiddenId.value))) {
          msg.textContent = 'このプリンターはすでに登録されています。'; msg.className = 'text-sm text-ink-red lg:col-span-3';
          return;
        }
        window.inkProcessing?.show();
        try {
          const j = await window.inkApi.post('/printer', { category_id: parseInt(hiddenId.value, 10) });
          // inkApi KHÔNG throw HTTP error (trả body json kể cả 4xx) → PHẢI check body
          // trước khi báo thành công. Server 422 trùng → error='printer_already_registered'
          // (MyPrinterController@store) → alert rõ ràng (#7.4); lỗi khác → message chung.
          // Giữ nguyên input để user sửa, KHÔNG reset form.
          if (!j || !j.data || !j.data.id) {
            const dup = j && j.error === 'printer_already_registered';
            msg.textContent = dup ? 'このプリンターはすでに登録されています。' : '登録できませんでした。時間をおいて再度お試しください。';
            msg.className = 'text-sm text-ink-red lg:col-span-3';
            return;
          }
          const newMemo = (addForm.elements.new_memo?.value || '').trim();
          if (newMemo) {
            try { await window.inkApi.patch(`/printer/${j.data.id}`, { note: newMemo }); } catch (e2) { console.warn('save new printer memo fail', e2); }
          }
          addForm.reset(); hiddenId.value = ''; hideS(); closeList();
          msg.textContent = '登録しました'; msg.className = 'text-sm font-bold text-ink-green lg:col-span-3';
          selectedId = j.data.id;
          await loadPrinters();
          setTimeout(() => { msg.textContent = ''; }, 2000);
        } catch (err) {
          // Chỉ còn exception bất ngờ (bug JS/network đã được inkApi nuốt) → message chung.
          console.warn('add printer fail', err);
          msg.textContent = '登録できませんでした。時間をおいて再度お試しください。';
          msg.className = 'text-sm text-ink-red lg:col-span-3';
        } finally { window.inkProcessing?.hide(); }
      });
    }

    // Scroll phải chờ `loadPrinters()` xong: panel + grid 対応商品 render sau đó đẩy
    // `addForm` xuống hàng trăm px, scroll trước là rơi vào giữa danh sách sản phẩm.
    loadPrinters().then(() => {
      const addForm = root.querySelector('[data-printer-add-form]');
      const preset = (new URLSearchParams(window.location.search).get('printer') || '').trim();
      if (addForm && preset.length >= 2) addForm.scrollIntoView({ block: 'center' });
    });
  }

  window.InkPrinterManager = { renderProducts, initPanel };
})();
